import { Component, OnInit } from '@angular/core';
import { AlertController, NavParams, PopoverController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { MatchService } from '../../_core/services/match.service';
import { ToastService } from '../../_core/services/toast.service';
import { Match } from '../../_shared/models/match.model';
import { Geolocation } from '@capacitor/geolocation';

@Component({
  standalone: false,
    selector: 'app-weather-update',
    templateUrl: './weather-update.component.html',
    styleUrls: ['./weather-update.component.scss'],
})
export class WeatherUpdateComponent implements OnInit {
    match: Match;
    isWeatherAvailable = false;
    isUpdating = false;
    constructor(
        private matchService: MatchService,
        private navParams: NavParams,
        private popoverController: PopoverController,
        private alertController: AlertController,
        private toast: ToastService) { }

    ngOnInit() {
        this.match = this.navParams.get('match');
        this.isWeatherAvailable = this.match.weather.main ? true : false;
    }

    async getCurrentWeather() {
        this.isUpdating = true;
        const geoData = await Geolocation.getCurrentPosition()
            .catch(async err => {
                const alert = await this.alertController.create({
                    header: 'Location is disabled',
                    message: 'To use this feature go to your settings to enable location.',
                    buttons: [
                        {
                            text: 'Ok',
                            handler: () => {
                                this.popoverController.dismiss();
                            }
                        }
                    ]
                });
                alert.present();
            }
            );
        if (geoData) {
            const weatherObj = {
                lon: geoData.coords.longitude,
                lat: geoData.coords.latitude
            };
            this.matchService
                .updateWeather(this.match._id, weatherObj)
                .pipe(finalize(() => this.isUpdating = false))
                .subscribe(
                    res => {
                        this.toast.presentToast(res.message);
                        this.popoverController.dismiss(res.data.weather);
                    },
                    err => {
                        //console.log(err)
                    }
                );
        }
    }
}
